import { Component, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Observable } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { ContratoService } from '../../../../providers/contrato-service';
import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';

import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

import { ModalArquivosPage } from "../../../modais/modal-arquivos/modal-arquivos";

declare var jsPDF: any;

@Component({
    selector: 'page-transferencia-recursos',
    templateUrl: 'transferencia-recursos.html',
    providers: [
        ContratosGestaoService
    ]
})
export class TransferenciaRecursosPage extends ModulosController {
    listaDados: any = [];
    listaContratos: any = [];
    listaContratosAux: any = [];
    loading: boolean = true;
    idSecaoPagina: string = "147";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];

    searchLoading: boolean = true;

    valorRetirado: any = 0;
    valorRetorno: any = 0;
    valorCorrecao: any = 0;

    codigoModulo: any = 0;

    relatorioParaAdicionar: any = {
        nmContrato: '',
        nmContratoDestino: '',
        credor: '',
        valorRetirado: '',
        dataRetornoRecurso: '',
        valorRetorno: '',
        valorCorrecao: '',
        dataReposicao: '',
        destinacaoValor: '',
        justificativa: ''
    }

    page1: number = 1;

    pagination = {
        TotalItems: 100,
        CurrentPage: 1,
        PageSize: 10,
        TotalPageLinkButtons: 5,
        RowsPerPageOptions: [10]
    };

    myDatePickerRetornoOptions: IMyDpOptions;
    myDatePickerReposicaoOptions: IMyDpOptions;

    typeahead = new EventEmitter<string>();

    objetoEdit: any = null;
    listEdit: any = [];

    comboContratos: any = null;
    comboContratosDestino: any = null;
    analise: any = null;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    desabilitarImportacao = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public contratoService: ContratoService,
        public contratosGestaoService: ContratosGestaoService,
        private fileService: FileService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        this.myDatePickerRetornoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };

        this.myDatePickerReposicaoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };

        if (this.isJurisdicionado) {
            this.codigoModulo = this.navParams.get('analise').idModuloPca;
        }

        this.carregarDados();
        this.setModuloId(14);

        //this.typeahead
           // .pipe(distinctUntilChanged(), debounceTime(200), switchMap(term => this.buscarContratos(term)))
           // .subscribe(items => {
            //    this.listaContratos = items;
            //}, (err) => {
             //   console.log(err);
              //  this.listaContratos = [];
           // });
    }

    carregarDados() {
       /* this.contratosGestaoService.obterAnalise(this.idSecaoPagina).subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });*/

        this.desabilitarImportacao = true;

        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(1, this.idSecaoPagina).subscribe(data => {
            this.listaDados = data.analises;
            this.loading = false;
            this.pagination.TotalItems = data.qtdPags;
            this.desabilitarImportacao = this.listaDados.length > 0;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });

        this.searchLoading = true;
        this.contratosGestaoService.obterContratosGestao().subscribe(data => {
            this.listaContratos = data;
            this.searchLoading = false;
        }, error => {
            console.log("erro: " + error);
            this.searchLoading = false;
        });
    }

    buscarContratos(term: string): Observable<any[]> {
        return this.contratosGestaoService.obterContratosGestaoPorNumero(term);
    }

    fileChangeMassa(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
            if (callback) {
                this.loading = true;
                this.fileService.cargaAnalises(event, this.idSecaoPagina).subscribe(data => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.dadosImportados = data;

                    for (let j = 0; j < this.dadosImportados.length; j++) {
                        this.listaDados.push(this.dadosImportados[j]);
                    }

                    this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
                    this.loading = false;
                }, error => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.alertService.mostraAlerta("Houve um erro ao carregar o arquivo.", error.mensagem);
                    this.loading = false;
                });
            } else {
                this.inputFileCMVar.nativeElement.value = "";
            }
        });
    }

    downloadDoModelo() {
        this.fileService.downloadModeloCargaContratoGestao(this.idSecaoPagina);
    }

    adicionarRelatorio() {

        if (this.relatorioParaAdicionar.valorRetorno == '') {
            this.relatorioParaAdicionar.valorRetorno = 0;
        }
        if (this.relatorioParaAdicionar.valorCorrecao == '') {
            this.relatorioParaAdicionar.valorCorrecao - 0;
        }

        if (this.relatorioParaAdicionar.nmContrato !== '' &&
            this.relatorioParaAdicionar.nmContratoDestino !== '' &&
            this.relatorioParaAdicionar.valorRetirado !== '' &&
            this.relatorioParaAdicionar.dataRetornoRecurso !== '' &&
            this.relatorioParaAdicionar.dataReposicao !== '' &&
            this.relatorioParaAdicionar.destinacaoValor !== '' &&
            this.relatorioParaAdicionar.justificativa !== '' && 
            this.relatorioParaAdicionar.justificativa !== undefined) {

            let relatorioNovo = {
                "id": 0,
                "idModuloAnalise": 0,
                "contratoGestao": {
                    "id": 0,
                    "nmContrato": this.relatorioParaAdicionar.nmContrato,
                    "credor": "",
                    "cpf": "",
                    "cnpj": "",
                    "objeto": "",
                    "dataAssinatura": "",
                    "inicioVigencia": "",
                    "fimVigencia": "",
                    "dataPublicacao": "",
                    "valorInicial": 0,
                    "responsavel": "",
                    "novaDataVigencia": "",
                    "valorAtual": 0,
                    "aditivos": [],
                    "flCertificado": false,
                    "situacao": "",
                    "dtPrazoPublicacao": "",
                    "diasForaDoPrazo": "",
                    "codSituacao": 0,
                    "arquivos": []
                },
                "nmContratoDestino": this.relatorioParaAdicionar.nmContratoDestino,
                //"contratoGestaoDestino": {
                  //  "id": 0,
                   // "nmContrato": this.relatorioParaAdicionar.nmContratoDestino,
                   // "credor": "",
                   // "cpf": "",
                   // "cnpj": "",
                   // "objeto": "",
                   // "dataAssinatura": "",
                   // "inicioVigencia": "",
                   // "fimVigencia": "",
                   // "dataPublicacao": "",
                   // "valorInicial": 0,
                   // "responsavel": "",
                   // "novaDataVigencia": "",
                   // "valorAtual": 0,
                   // "aditivos": [],
                   // "flCertificado": false,
                   // "situacao": "",
                   // "dtPrazoPublicacao": "",
                   // "diasForaDoPrazo": "",
                   // "codSituacao": 0,
                   // "arquivos": []
                //},
                "dsMetas": "",
                "dsAtividade": "",
                "quantidadePrevista": 0,
                "valorUnitarioPrevisto": 0,
                "totalPrevisto": 0,
                "quantidadeRealizada": 0,
                "valorUnitarioRealizado": 0,
                "totalRealizado": 0,
                "recursosRecebidos": 0,
                "restituicoes": 0,
                "transferencias": 0,
                "rendAcumulados": 0,
                "outrasReceitas": 0,
                "despesasPeriodo": 0,
                "despesasFinanceiras": 0,
                "tipoDespesa": "",
                "naturezaDespesa": "",
                "numeroCheque": "",
                "dataEmissao": "",
                "dataPagamento": "",
                "valorDocumento": "",
                "valorPago": "",
                "numeroEditalCotacao": "",
                "dataEditalCotacao": "",
                "exercicio": "",
                "valorRetirado": this.relatorioParaAdicionar.valorRetirado,
                "dataRetornoRecurso": this.relatorioParaAdicionar.dataRetornoRecurso,
                "valorRetorno": this.relatorioParaAdicionar.valorRetorno,
                "valorCorrecao": this.relatorioParaAdicionar.valorCorrecao,
                "justificativa": this.relatorioParaAdicionar.justificativa,
                "destinacaoValor": this.relatorioParaAdicionar.destinacaoValor,
                "prazoReposicao": this.relatorioParaAdicionar.dataReposicao,
                "orgSocial": "",
                "nomePessoa": "",
                "dataAdmissao": "",
                "dataDesligamento": "",
                "funcaoDesenvolvida": "",
                "cpf": "",
                "valorJaneiro": 0,
                "valorFevereiro": 0,
                "valorMarco": 0,
                "valorAbril": 0,
                "valorMaio": 0,
                "valorJunho": 0,
                "valorJulho": 0,
                "valorAgosto": 0,
                "valorSetembro": 0,
                "valorOutubro": 0,
                "valorNovembro": 0,
                "valorDezembro": 0,
                "totalExercicio": 0
            };

            // let tipoVinculoTemp = this.listaContratosAux.filter((contrato) => this.relatorioParaAdicionar.nmContrato == contrato.nmContrato)[0];

            this.contratoService.obterPorNumeroContrato(this.relatorioParaAdicionar.nmContrato).subscribe(data => {
                if (data != null) {
                    relatorioNovo.contratoGestao.id = data.id;
                    relatorioNovo.contratoGestao.nmContrato = data.nmContrato;
                    relatorioNovo.contratoGestao.credor = data.credor;
                    relatorioNovo.contratoGestao.cpf = data.cpf;
                    relatorioNovo.contratoGestao.cnpj = data.cnpj;
                    relatorioNovo.contratoGestao.objeto = data.objeto;
                    relatorioNovo.contratoGestao.dataAssinatura = data.dataAssinatura;
                    relatorioNovo.contratoGestao.inicioVigencia = data.inicioVigencia;
                    relatorioNovo.contratoGestao.fimVigencia = data.fimVigencia;
                    relatorioNovo.contratoGestao.dataPublicacao = data.dataPublicacao;
                    relatorioNovo.contratoGestao.valorInicial = data.valorInicial;
                    relatorioNovo.contratoGestao.responsavel = data.responsavel;
                    relatorioNovo.contratoGestao.novaDataVigencia = data.novaDataVigencia;
                    relatorioNovo.contratoGestao.valorAtual = data.valorAtual;
                    relatorioNovo.contratoGestao.aditivos = data.aditivos;
                    relatorioNovo.contratoGestao.flCertificado = data.flCertificado;
                    relatorioNovo.contratoGestao.situacao = data.situacao;
                    relatorioNovo.contratoGestao.dtPrazoPublicacao = data.dtPrazoPublicacao;
                    relatorioNovo.contratoGestao.diasForaDoPrazo = data.diasForaDoPrazo;
                    relatorioNovo.contratoGestao.codSituacao = data.codSituacao;
                    relatorioNovo.contratoGestao.arquivos = data.arquivos;
                }

                //this.contratoService.obterPorNumeroContrato(this.relatorioParaAdicionar.nmContratoDestino).subscribe(data => {
                  //  if (data != null) {
                    //    relatorioNovo.contratoGestaoDestino.id = data.id;
                    //    relatorioNovo.contratoGestaoDestino.nmContrato = data.nmContrato;
                    //    relatorioNovo.contratoGestaoDestino.credor = data.credor;
                    //    relatorioNovo.contratoGestaoDestino.cpf = data.cpf;
                    //    relatorioNovo.contratoGestaoDestino.cnpj = data.cnpj;
                    //    relatorioNovo.contratoGestaoDestino.objeto = data.objeto;
                    //    relatorioNovo.contratoGestaoDestino.dataAssinatura = data.dataAssinatura;
                    //    relatorioNovo.contratoGestaoDestino.inicioVigencia = data.inicioVigencia;
                    //    relatorioNovo.contratoGestaoDestino.fimVigencia = data.fimVigencia;
                    //    relatorioNovo.contratoGestaoDestino.dataPublicacao = data.dataPublicacao;
                    //    relatorioNovo.contratoGestaoDestino.valorInicial = data.valorInicial;
                    //    relatorioNovo.contratoGestaoDestino.responsavel = data.responsavel;
                    //    relatorioNovo.contratoGestaoDestino.novaDataVigencia = data.novaDataVigencia;
                    //    relatorioNovo.contratoGestaoDestino.valorAtual = data.valorAtual;
                    //    relatorioNovo.contratoGestaoDestino.aditivos = data.aditivos;
                    //    relatorioNovo.contratoGestaoDestino.flCertificado = data.flCertificado;
                    //    relatorioNovo.contratoGestaoDestino.situacao = data.situacao;
                    //    relatorioNovo.contratoGestaoDestino.dtPrazoPublicacao = data.dtPrazoPublicacao;
                    //    relatorioNovo.contratoGestaoDestino.diasForaDoPrazo = data.diasForaDoPrazo;
                    //    relatorioNovo.contratoGestaoDestino.codSituacao = data.codSituacao;
                    //    relatorioNovo.contratoGestaoDestino.arquivos = data.arquivos;
                   // }
                //});

                //if (this.listaDados.findIndex(i => {return i.contratoGestao.nmContrato === relatorioNovo.contratoGestao.nmContrato}) != -1 
                //    && !this.objetoEdit) {
                //    this.alertService.mostraAlerta("", "Contrato já adicionado!");
                //} else {
                    if (this.objetoEdit) {
                        let index = this.listaDados.indexOf(this.objetoEdit);
                        this.listaDados.splice(index, 1);

                        this.listEdit.push(this.objetoEdit);
                    }

                    this.listaDados.push(relatorioNovo);

                    this.objetoEdit = null;

                    this.relatorioParaAdicionar.nmContrato =
                    this.relatorioParaAdicionar.nmContratoDestino =
                    this.relatorioParaAdicionar.credor =
                    this.relatorioParaAdicionar.valorRetirado =
                    this.relatorioParaAdicionar.dataRetornoRecurso =
                    this.relatorioParaAdicionar.dataReposicao =
                    this.relatorioParaAdicionar.valorRetorno =
                    this.relatorioParaAdicionar.destinacaoValor =
                    this.relatorioParaAdicionar.justificativa =
                    this.relatorioParaAdicionar.valorCorrecao = '';

                    this.comboContratos = null;
                    this.comboContratosDestino = null;

                    let copy = {
                        dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                        monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
                        dateFormat: 'dd/mm/yyyy',
                        todayBtnTxt: 'Hoje',
                        firstDayOfWeek: 'su',
                        disableWeekends: false,
                        editableDateField: true,
                        openSelectorOnInputClick: true,
                        showClearDateBtn: false
                    };

                    this.myDatePickerRetornoOptions = copy;
                    this.myDatePickerReposicaoOptions = copy;
                //}
            
            }, error => {
                console.log("erro: " + error);
                this.searchLoading = false;
            });
        } else {
            console.log(this.relatorioParaAdicionar);
            this.alertService.mostraAlerta("", "Necessário preencher todos os campos do formulário.");
        }

    }

    onContratoChange(contrato) {
        if (contrato != null && contrato != undefined) {
            this.relatorioParaAdicionar.nmContrato = contrato.nmContrato;
            this.relatorioParaAdicionar.credor = contrato.dsCredor;
        } else {
            this.relatorioParaAdicionar.nmContrato = '';
            this.relatorioParaAdicionar.credor = '';
        }
    }

    onDataRetornoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.relatorioParaAdicionar.dataRetornoRecurso = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    onDataReposicaoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.relatorioParaAdicionar.dataReposicao = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    removerRelatorio(item, edit) {

        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
                if (callback) {

                    let index = this.listaDados.indexOf(item);
                    this.listaDados.splice(index, 1);

                    if (item.id != 0) {
                        this.deletarRelatorio(item.id, edit);
                    }
                }
            });
        } else {
            // let index = this.listaDados.indexOf(item);
            // this.listaDados.splice(index, 1);

            if (item.id != 0) {
                this.deletarRelatorio(item.id, edit);
            }
        }
    }

    formatarValorNumerico(valor) {
        if (isNaN(valor)) {
            valor = 0;
        }

        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaContratosGestao() {
        this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
    }

    salvar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        this.contratosGestaoService.salvarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.carregarDados();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        })
    }

    deletarRelatorio(idContratoGestao, edit) {
        this.contratosGestaoService.deletarAnalise(idContratoGestao, this.idSecaoPagina).subscribe(data => {
            if (!edit) {
                this.alertService.mostraAlerta("", "Removido com sucesso.");
            }
        }, error => {
            this.alertService.mostraAlerta("Erro ao excluir", "O registro pode estar vinculado a outra análise no sistema.");
            this.carregarDados();
        })
    }

    finalizar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        if (this.listaDados) {
            this.contratosGestaoService.finalizarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaContratosGestao();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
            });
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    calcularCorrecao() {

        if (this.relatorioParaAdicionar.valorRetirado == "" || this.relatorioParaAdicionar.valorRetirado == null || this.relatorioParaAdicionar.valorRetirado == undefined || isNaN(this.relatorioParaAdicionar.valorRetirado)) {
            this.valorRetirado = 0;
        } else {
            this.valorRetirado = this.relatorioParaAdicionar.valorRetirado;
        }

        if (this.relatorioParaAdicionar.valorRetorno == "" || this.relatorioParaAdicionar.valorRetorno == null || this.relatorioParaAdicionar.valorRetorno == undefined || isNaN(this.relatorioParaAdicionar.valorRetorno)) {
            this.valorRetorno = 0;
        } else {
            this.valorRetorno = this.relatorioParaAdicionar.valorRetorno;
        }

        this.valorCorrecao = parseFloat(this.valorRetorno) - parseFloat(this.valorRetirado);
        this.relatorioParaAdicionar.valorCorrecao = this.valorCorrecao;

        return this.valorCorrecao;
    }

    modalEvidencias(item: any) {

        let titulo = "Evidências";
        console.log(item);
        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.contratoGestao.nmContrato,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: 0,
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Contrato: " + item.contratoGestao.nmContrato,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });

        modal.present();

    }

    editar(item) {
        this.comboContratos = item.contratoGestao.nmContrato;
        this.comboContratosDestino = item.nmContratoDestino;
        this.relatorioParaAdicionar.nmContrato = item.contratoGestao.nmContrato;
        this.relatorioParaAdicionar.nmContratoDestino = item.nmContratoDestino;
        this.relatorioParaAdicionar.credor = item.contratoGestao.credor;
        this.relatorioParaAdicionar.valorRetirado = item.valorRetirado;
        this.relatorioParaAdicionar.dataRetornoRecurso = item.dataRetornoRecurso;
        this.relatorioParaAdicionar.dataReposicao = item.prazoReposicao;
        this.relatorioParaAdicionar.valorRetorno = item.valorRetorno;
        this.relatorioParaAdicionar.destinacaoValor = item.destinacaoValor;
        this.relatorioParaAdicionar.justificativa = item.justificativa;
        this.relatorioParaAdicionar.valorCorrecao = item.valorCorrecao;

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Transferência de Recursos entre Contratos de Gestão", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Nº Contrato SAC/SCC", dataKey: "contrato" },
            { title: "Nº Contrato SAC/SCC Destino", dataKey: "contratoDestino" },
            { title: "Valor Empréstimo", dataKey: "emprestimo" },
            { title: "Data Reposição", dataKey: "dtRep" },
            { title: "Prazo Reposição", dataKey: "prazo" },
            { title: "Valor Devolvido", dataKey: "valDev" },
            { title: "Valor da Correção", dataKey: "valCor" },
            { title: "Destinação do Valor", dataKey: "dest" }
        ];

        let rows = [];

        this.listaDados.forEach(contrato => {

            var item = {
                "contrato": contrato.contratoGestao.nmContrato,
                "contratoDestino": contrato.nmContratoDestino,
                "emprestimo": this.formatarValorNumerico(contrato.valorRetirado),
                "dtRep": contrato.dataReposicao,
                "prazo": contrato.prazoReposicao,
                "valDev": this.formatarValorNumerico(contrato.valorRetorno),
                "valCor": this.formatarValorNumerico(contrato.valorCorrecao),
                "dest": contrato.destinacaoValor
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            theme: 'grid',
            addPageContent: pageContent,
            margin: { top: 30 },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'auto',
                fontSize: 8
            },
            columnStyles: {
                desc: { columnWidth: 'auto' }
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save('transferencia_recursos.pdf');
    }

    loadPage(Page: number) {
        this.pagination.CurrentPage = Page;
        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(Page, this.idSecaoPagina).subscribe(data => {
          this.listaDados =  data.analises;
          this.loading = false;
          this.pagination.TotalItems = data.qtdPags;
        }, error => {
          console.log("erro: " + error.mensagem);
          this.loading = false;
        });
      }
    
      deletarTodos(){
        this.alertService.mostraModalConfirmacao("Excluir os registros", "Deseja excluir " + this.pagination.TotalItems + " registro(s)?", callback => {
            if (callback) {
                this.loading = true;
                this.contratosGestaoService.deletarTodos(this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("Exclusão concluída","Todos os registros foram excluídos.");
                    this.carregarDados();
                }, error => {
                    this.alertService.mostraAlerta("Erro ao excluir", "Algum registro pode estar vinculado a outra análise no sistema.");
                    this.carregarDados();                   
                });
            }
        });        
      }

      importarDoAnoAnterior() {

        this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
            "Recomenda-se realizar a importação dos dados por meio do template de carga em massa."+
            "<br />Deseja continuar a importação dos registros do ano anterior mesmo assim?", 
            callback => {            
                if (callback) {
                    this.loading = true;
                    this.desabilitarImportacao = true;
                    this.contratosGestaoService.carregarAnoAnterior(this.idSecaoPagina).subscribe(data => {
                        this.alertService.mostraAlerta("", data.mensagem);
                        this.carregarDados();
                    }, error => {
                        console.log("erro: " + error.mensagem);
                        this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                        this.carregarDados();
                    });
                }
            }
        );

    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/transferencia-recursos/transferencia-recursos.ts